//eslint-disable-next-line no-restricted-imports
import { TypographyOptions } from '@material-ui/core/styles/createTypography';

export const typography: TypographyOptions = {
  h1: {
    fontFamily: 'Open Sans',
    fontSize: 44,
    lineHeight: 1.17,
    fontWeight: 400,
    textTransform: 'capitalize',
    '&.bold': {
      fontWeight: 700,
    },
    '&.metric1': {
      fontSize: 40,
      lineHeight: 1.1,
      letterSpacing: 0,
    },
    '&.metric2': {
      fontSize: 48,
      lineHeight: 1.1,
      letterSpacing: 0,
    },
    '&.metric3': {
      fontSize: 24,
      lineHeight: 1.5,
      letterSpacing: 0,
    },
    '&.metric4': {
      fontSize: 22,
      lineHeight: 1.5,
      letterSpacing: 0,
    },
  },
  h2: {
    fontFamily: 'Open Sans',
    fontSize: 36,
    lineHeight: 1.25,
    fontWeight: 400,
    textTransform: 'capitalize',
    '&.bold': {
      fontWeight: 700,
    },
  },
  h3: {
    fontFamily: 'Open Sans',
    fontSize: 30,
    lineHeight: 1.41,
    fontWeight: 400,
    textTransform: 'capitalize',
    '&.bold': {
      fontWeight: 700,
    },
  },
  h4: {
    fontFamily: 'Open Sans',
    fontSize: 22,
    lineHeight: 1.42,
    fontWeight: 400,
    textTransform: 'capitalize',
    '&.bold': {
      fontWeight: 700,
    },
  },
  h5: {
    fontFamily: 'Open Sans',
    fontSize: 20,
    lineHeight: 1.33,
    fontWeight: 400,
    textTransform: 'capitalize',
    '&.bold': {
      fontWeight: 700,
    },
  },
  h6: {
    fontFamily: 'DINPro',
    fontSize: 16,
    lineHeight: 1.2,
    fontWeight: 400,
    textTransform: 'capitalize',
    '& *': {
      fontFamily: 'DINPro',
    },
    '&.bold': {
      fontWeight: 700,
    },
  },
  subtitle1: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 700,
  },
  subtitle2: {
    fontFamily: 'Open Sans',
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 700,
  },
  body1: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 400,
    '&.bold': {
      fontWeight: 600,
    },
  },
  body2: {
    fontFamily: 'Open Sans',
    fontSize: 14,
    letterSpacing: '0.1px',
    lineHeight: '22px',
    fontWeight: 400,
    '&.bold': {
      fontWeight: 600,
    },
  },
  button: {
    fontFamily: 'DINPro',
    fontSize: 14,
    lineHeight: 'normal',
    fontWeight: 700,
    textTransform: 'uppercase',
    '& *': {
      fontFamily: 'DINPro',
    },
  },
  caption: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    lineHeight: 1.3,
    fontWeight: 600,
    '&.bold': {
      fontWeight: 700,
    },
    '&.regular': {
      fontWeight: 400,
    },
  },
  overline: {
    fontFamily: 'DINPro',
    fontSize: 12,
    lineHeight: 1.3,
    letterSpacing: 'inherit',
    margin: 0,
    fontWeight: 600,
    '& *': {
      fontFamily: 'DINPro',
    },
    '&.bold': {
      fontWeight: 700,
    },
    '&.capitalize': {
      textTransform: 'capitalize',
    },
  },
};
